import React, {memo, useCallback, useState} from "react"
import "./index.scss"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useBackground} from "../../../../hooks/background-class"
import iconTheme1 from "../../../../assets/images/icons/theme1.png"
import iconTheme2 from "../../../../assets/images/icons/theme2.png"
import {useRPC} from "../../../../hooks/rpc"

export const CustomIconTheme = memo(function CustomIconTheme() {
    const [, , backgroundStyle] = useBackground()
    const [activeTheme, setActiveTheme] = useState(false)
    const [activeTheme2, setActiveTheme2] = useState(false)
    const [rpc] = useRPC()
    const theme1 = useCallback(() => {
        if (activeTheme) {
            return
        }
        setActiveTheme2(false)
        setActiveTheme(true)
        rpc.setTheme("images_two")
    }, [rpc, activeTheme])

    const theme2 = useCallback(() => {
        if (activeTheme2) {
            return
        }
        setActiveTheme(false)
        setActiveTheme2(true)
        rpc.setTheme("images_one")
    }, [rpc, activeTheme2])

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                backUrl={"/settings/custom-menu"}
                className={"background-settings"}
                style={backgroundStyle}
            >
                <div className="icon-theme-container">
                    <div className={`icon-theme-box ${activeTheme && "icon-theme-active"}`} onClick={theme1}>
                        <img src={iconTheme1} alt="" />
                    </div>
                    <div className={`icon-theme-box ${activeTheme2 && "icon-theme-active"}`} onClick={theme2}>
                        <img src={iconTheme2} alt="" />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
